const e=async(e,t,n,r,i)=>{let{data:a}=await e.post(`/webhooks/${t}/${n}/${r}/subscriptions`,i);return a};export{e as createWebhookSubscription};
//# sourceMappingURL=create-subscription.mjs.map